import { Field } from '@atlaskit/form';
import Toggle from '@atlaskit/toggle';
import { H4 } from '@atlassian/amkt-common';
import React from 'react';
import SupportHoursFormSection from "./SupportHoursFormSection/SupportHoursFormSection";

const ServiceAvailabilityFormSection = props => {
  const supportHours = props.supportDetails.supportHours;
  const providesSupportHours = !!(supportHours !== null && supportHours !== void 0 && supportHours.timezone);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H4, null, "Service Availability"), /*#__PURE__*/React.createElement(Field, {
    name: "providesSupportHours",
    defaultValue: providesSupportHours
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Toggle, {
    isChecked: fieldProps.value,
    onChange: e => {
      fieldProps.onChange(e);
    },
    size: "large"
  }), /*#__PURE__*/React.createElement("span", null, " Display service availability in your listing.")), fieldProps.value && /*#__PURE__*/React.createElement(SupportHoursFormSection, props))));
};

export default ServiceAvailabilityFormSection;